import { UIText2 } from '@cian/ui-kit';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { ETransportType, IUnderground } from '../../../../types/newbuildingHeader';
import { UndergroundIcon } from '../UndergroundIcon';

interface IUndergroundProps {
  underground: IUnderground;
}

export const Underground: React.FC<IUndergroundProps> = ({ underground }) => {
  return (
    <div className={styles['underground']}>
      <div className={styles['undergroundIcon']}>
        <UndergroundIcon lineColor={underground.lineColor} type={underground.undergroundType} />
      </div>
      <UIText2 color="text-primary-default">{underground.name}</UIText2>
      {underground.timeDisplay && (
        <>
          <div className={styles['travelTimeIcon']}>
            {underground.transportType === ETransportType.Transport ? <IconMapCar16 /> : <IconMapWalk16 />}
          </div>
          <UIText2 color="text-secondary-default">{underground.timeDisplay}</UIText2>
        </>
      )}
    </div>
  );
};
